import Box from "@mui/material/Box";
import * as theme from '../../../theme';
import { Typography } from '@mui/material';
import TextField from "@mui/material/TextField";
import StateSelect from '../../../components/StateSelect';
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ErrorDisplay from '../../../components/ErrorDisplay';

export default function PaymentDetails({
  billingInfo,
  handleBillingInfoChange,
  handleBillingStateChange,
  nonce,
  nonceError,
  setNonceError,
  handleTokenizeResponse,
  isBillingValid,
  storeCardConsent,
  handleStoreCardConsentChange
}) {
  return (
    <Box sx={{ ...theme.FullForm.form, gap: 2 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Provide a payment method for your subscription. We will store this card on file. This card will not be charged until on the final step.
      </Typography>
      {nonceError && <ErrorDisplay message={nonceError} type="error" clearMessage={() => setNonceError('')} />}
      {!nonce ? (
        <>
          <TextField
            label="Cardholder Name"
            name="cardholderName"
            value={billingInfo.cardholderName}
            onChange={handleBillingInfoChange}
            variant="filled"
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Billing Address"
            name="addressLine1"
            value={billingInfo.addressLine1}
            onChange={handleBillingInfoChange}
            variant="filled"
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Address Line 2"
            name="addressLine2"
            value={billingInfo.addressLine2}
            onChange={handleBillingInfoChange}
            variant="filled"
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="City"
            name="city"
            value={billingInfo.city}
            onChange={handleBillingInfoChange}
            variant="filled"
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", width: '100%', gap: 2, mb: 2 }}>
            <StateSelect 
              value={billingInfo.state} 
              onChange={handleBillingStateChange}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Zip Code"
              name="zip"
              value={billingInfo.zip}
              onChange={handleBillingInfoChange}
              variant="filled"
              required
              sx={{ flex: 1 }}
            />
          </Box>
          <PaymentForm
            applicationId={process.env.REACT_APP_SQUARE_APP_ID}
            locationId={process.env.REACT_APP_SQUARE_LOCATION_ID}
            cardTokenizeResponseReceived={(token) => handleTokenizeResponse(token)}
            createVerificationDetails={() => ({
              intent: 'STORE',
              billingContact: {
                addressLines: [billingInfo.addressLine1, billingInfo.addressLine2 || ''],
                countryCode: 'US',
                region: billingInfo.state,
                postalCode: billingInfo.zip,
                city: billingInfo.city
              }
            })}
          >
            <CreditCard 
              buttonProps={{
                css: {
                  backgroundColor: theme.Colors.GoldDark,
                  color: theme.Colors.GrayDark,
                  fontSize: 14,
                  '&:hover': { backgroundColor: '#8A7B5D' },
                },
                isLoading: !isBillingValid
              }}
            >Verify Card Details</CreditCard>
          </PaymentForm>
        </>
      ) : (
        <>
          <Box sx={{ p: 2, border: 1, borderColor: theme.Colors.GrayLight, borderRadius: 1, mb: 2 }}>
            <Typography variant="body2">
              I authorize this business to keep my credit card on file for any future transactions until I request a cancellation. I understand that the terms of this authorization will remain in effect until I request that they be terminated. I acknowledge that I am responsible for making this request in writing.
            </Typography>
          </Box>
          <FormControlLabel
            control={<Checkbox checked={storeCardConsent} onChange={handleStoreCardConsentChange} required />}
            label="I agree to store my card on file."
          />
        </>
      )}
    </Box>
  );
}